import './bootstrap';

Alpine.start()